import { createSlice } from '@reduxjs/toolkit';
import { moduleName } from '../../moduleInfo';

const paymentMethodSlice = createSlice({
  name: `${moduleName}/paymentMethod`,
  initialState: {
    loading: false,
    payuStatus: [],
    error: '',
  },
  reducers: {},
  extraReducers: {},
});

export default paymentMethodSlice.reducer;
